import Symbol from "./Symbol";
import { INSPECTOR_RESTAURATEUR } from "../../../constants/inspectorConstants";

// Restaurador
class Restaurateur extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("Restaurateur", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente nominal" },
            interruptingCapacity: { isVisible: false, value: null, label: "Capacidad interruptiva" },
            currentTransformerRatio: { isVisible: false, value: null, label: "Relación de transformadores de corriente" },
        };                
    }

    getInspector() {
        return INSPECTOR_RESTAURATEUR;
    }
}

export default Restaurateur;
